import welcomeImg from '../assets/welcomeImg.png';
import { Colors, Fonts } from '../utils/constants';
import { blueBg, center } from './CommonStyles';

export const welcomeImage = {
    backgroundImage: `url(${welcomeImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
};

export const spaceContainer = {
    width: '75%',
};

export const responsiveSpaceContainer = {
    ...spaceContainer,
    textAlign: 'center'
};

export const logoImg = {
    maxWidth: '40%',
    marginBottom: "5vh",
    marginTop: "10vh"
};

export const responsiveLogoImg = {
    maxWidth: '70%',
    margin: '30px 0px',
};

export const bestPlanTxt = {
    color: 'white',
    fontSize: 34,
    fontFamily: Fonts.sspBold,
    marginBottom: 25,
    lineHeight: 1.2
};

export const knowLeaseTxt = {
    color: 'white',
    fontSize: 18,
    fontFamily: Fonts.sspLight,
};

export const quoteBttn = {
    cursor: 'pointer',
    backgroundColor: Colors.yellow,
    color: Colors.blue,
    fontSize: 16,
    fontFamily: Fonts.sspBold,
    padding: '12px 42px',
    borderRadius: 36,
    borderWidth: 0
};

export const responsiceQuoteBttn = {
    ...quoteBttn,
    marginBottom: 40
};

export const informationContainer = {
    ...blueBg, 
    ...center
};